const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.shows.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllVenueShowsQueryOptions } from '@api';
import { createTableQuerySchema, getTableParams } from '@common*';
import { createFileRoute } from '@tanstack/react-router';
const TABLE_ID_CONFIRMED = 'confirmedShows';
const TABLE_ID_UNCONFIRMED = 'unconfirmedShows';
const searchSchema = createTableQuerySchema({
  tableIds: [TABLE_ID_CONFIRMED, TABLE_ID_UNCONFIRMED]
});
export const Route = createFileRoute('/_rootLayout/venues/$id/shows')({
  validateSearch: search => searchSchema.parse(search),
  beforeLoad: () => {
    return {
      tableIdConfirmed: TABLE_ID_CONFIRMED,
      tableIdUnconfirmed: TABLE_ID_UNCONFIRMED
    };
  },
  loader: async ({
    context: {
      queryClient
    },
    params,
    location
  }) => {
    const tableParamsConfirmed = getTableParams(location.search, TABLE_ID_CONFIRMED);
    const tableParamsUnconfirmed = getTableParams(location.search, TABLE_ID_UNCONFIRMED);
    queryClient.ensureQueryData(getFindAllVenueShowsQueryOptions(params.id, {
      type: 'CONFIRMED',
      ...tableParamsConfirmed
    }));
    queryClient.ensureQueryData(getFindAllVenueShowsQueryOptions(params.id, {
      type: 'UNCONFIRMED',
      ...tableParamsUnconfirmed
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});